export default "__VITE_ASSET__Cach2h4W__"